import { useMemo, useState } from 'react';
import { Table, Button, Modal, Avatar, Flex, Typography, Tag } from 'antd';
import { useParams, useNavigate } from 'react-router-dom';
import { useGetInspectionPlanByProjectQuery } from '../../../../redux/api/quality';
import { getTagColor } from "../../../../utils/";
import SampleMatrixTable from '../../../../components/Operations/Quality/SampleMatrixTable';

const { Title, Text } = Typography;

const ProductPage = () => {
  const projectId = useParams<{ id: string }>();


  const navigate = useNavigate();
  const [modalData, setModalData] = useState(null);
  const [passedSample, setPassedSample] = useState<any | null>(null);

  const {
    data: planData,
    isLoading: isLoading,
    error: error,
  } = useGetInspectionPlanByProjectQuery({ projectId: projectId!, samples: 'full', project_mode: 'condensed' },
    { skip: !projectId, refetchOnMountOrArgChange: true });

 
  const projectInfo = planData?.project?.order_line_item;

  return (
    <div>
      <Flex justify="start" align="center" className='w-full' style={{ marginBottom: 24 }}>
        <Button type="link" onClick={() => navigate(-1)}>
          ← Back
        </Button>
      </Flex>

      <Flex justify="space-between" align="center" style={{ marginBottom: 24 }}>
        <div>
          <Title level={4}>{planData?.name}</Title>
          {projectInfo && (
            <>
              <Text strong>Quality Status:</Text> <Tag color={getTagColor(projectInfo.quality_status)}>{projectInfo.quality_status} </Tag> <br />
              <Text strong>Due Date:</Text> {projectInfo.due_date}
            </>
          )}
        </div>
        {projectInfo?.thumbnail_file && (
          <Avatar shape="square" size={64} src={projectInfo.thumbnail_file} />
        )}
      </Flex>
      <SampleMatrixTable projectId={projectId}></SampleMatrixTable>
     
    </div>
  );
};

export default ProductPage;


